export enum IntegrationProductType {
  APP = 'APP',
  AGENT = 'AGENT',
  CONNECTOR = 'CONNECTOR',
  WORKFLOW_TEMPLATE = 'WORKFLOW_TEMPLATE',
  UNKNOWN = 'UNKNOWN',
}
